<template>
  <div class="app-container">
    <div class="" ref="searchBox" style="padding-top: 8px;">
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent" highlight-current-row center border :cell-style="setCellStyle" >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="teamName" width="" label="小队"></el-table-column>
        <el-table-column prop="total" width="" label="应出车数"></el-table-column>
        <el-table-column label="车辆状态">
          <el-table-column prop="working" width="" label="作业中"></el-table-column>
          <el-table-column prop="maintaining" width="" label="维修中"></el-table-column>
          <el-table-column prop="charging" width="" label="充电中"></el-table-column>
          <el-table-column prop="idle" width="" label="空闲"></el-table-column>
          <el-table-column prop="blacklist" width="" label="拉黑"></el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页-->
    <div>
      <!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.pageNo" :page-sizes="[10, 20, 25, 50, 100]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination> -->
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { statusByTeam } from '@/api/vgs-driver2.0'
import { dateFormat1, dateTimeFormat, emptyFn, toFixed } from '@/utils/util'
export default {
  name: 'BasicMeterial',
  components: { },
  data () {
    return {
      toFixed: toFixed,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      searchForm: {
      },
      tableList: [],
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: [],
      h: ''
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/realTimeVehicle')
    this.masterList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 130 + 'px'
  },
  methods: {
    // 设置单元格样式
    setCellStyle ({ row, column, rowIndex, columnIndex }) {
      // 判断 teamName 是否为"合计"
      if (row.teamName === '合计') {
        // 如果是序号列，将内容设为空字符串
        if (column.type === 'index') {
          return {
            color: '',
            fontWeight: '',
            '&::before': {
              content: '""' // 伪元素方式清空内容
            }
          }
        }
        return {
          color: '#1890ff',
          fontWeight: 'bold'
        }
      }
      return null
    },
    masterList () {
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      statusByTeam()
        .then(res => {
          console.log(res)
          loading.close()
          this.tableList = res.list
          // this.total = res.total
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    searchFn () {
      this.masterList()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.masterList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.masterList()
    }
  }
}
</script>

<style scoped lang="less">
</style>
